import React, { useState, useRef, useEffect } from 'react';
import { useI18n } from '../hooks/useI18n';
import RedSquare from '../components/RedSquare/RedSquare';
import TeamMemberSection from '../components/TeamMemberSection/TeamMemberSection';
import { leads, developers, designers, composers, legalteam } from '../constants/teamMembers';
import {
  AboutPageContainer,
  AboutContentSection,
  AboutHeaderImage,
  AboutContentContainer,
  AboutLeftColumn,
  AboutGif,
  AboutRightColumn,
  AboutText,
  TeamSection,
  TeamTitleContainer,
  TeamTitle,
} from './Pages.styles';
import headerImageEn from '../assets/QUE_ES_KIMERAWARE_ENG.png';
import headerImageEs from '../assets/QUE_ES_KIMERAWARE.png';
import kimeraGif from '../assets/KimeraWare.gif';
import KimeraWareSocialMedia from '../components/KimeraWareSocialMedia/KimeraWareSocialMedia';
import { FOOTER_CONTACT } from '../components/Footer/Footer.constants';
import { SEO } from '../components/SEO/SEO';
import { dura } from '../constants/easteregg';

const AboutPage: React.FC = () => {
  const { t, language } = useI18n();
  const [isEasterEggActive, setIsEasterEggActive] = useState<boolean>(false);
  const textSequenceRef = useRef<string>('');
  const textTimeoutRef = useRef<number | null>(null);

  const headerImage = language === 'es' ? headerImageEs : headerImageEn;

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      const key = event.key;
      const keyUpper = key.toUpperCase();

      if (textTimeoutRef.current) {
        clearTimeout(textTimeoutRef.current);
      }

      const newTextSequence = textSequenceRef.current + keyUpper;

      if ('HOMERO'.startsWith(newTextSequence)) {
        textSequenceRef.current = newTextSequence;

        if (newTextSequence === 'HOMERO') {
          setIsEasterEggActive(true);
          textSequenceRef.current = '';
        } else {
          textTimeoutRef.current = window.setTimeout(() => {
            textSequenceRef.current = '';
          }, 2000);
        }
      } else {
        textSequenceRef.current = '';
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      if (textTimeoutRef.current) {
        clearTimeout(textTimeoutRef.current);
      }
    };
  }, []);

  return (
    <AboutPageContainer id="about">
      <SEO
        title={t('seo.about.title')}
        description={t('seo.about.description')}
        keywords={t('seo.about.keywords')}
        canonicalUrl="/about"
        type="website"
      />
      <AboutContentSection>
        <AboutHeaderImage src={headerImage} alt={t('about.headerImageAlt')} />
        <AboutContentContainer>
          <AboutLeftColumn>
            <AboutGif src={kimeraGif} alt={t('about.gifAlt')} />
          </AboutLeftColumn>
          <AboutRightColumn>
            <AboutText>{isEasterEggActive ? dura : t('about.content')}</AboutText>
          </AboutRightColumn>
        </AboutContentContainer>
        <KimeraWareSocialMedia size={'medium'} />
        <AboutText>{FOOTER_CONTACT.EMAIL}</AboutText>
      </AboutContentSection>
      <TeamSection>
        <TeamTitleContainer>
          <RedSquare size="large" />
          <TeamTitle>{t('about.teamTitle')}</TeamTitle>
          <RedSquare size="large" />
        </TeamTitleContainer>
      </TeamSection>
      <TeamMemberSection titleKey="about.theHeadsOfTheKimera" members={leads} />
      <TeamMemberSection titleKey="about.developers" members={developers} />
      <TeamMemberSection titleKey="about.illustrators" members={designers} />
      <TeamMemberSection titleKey="about.composers" members={composers} />
      <TeamMemberSection titleKey="about.legalTeam" members={legalteam} />
    </AboutPageContainer>
  );
};

export default AboutPage;
